"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vMoney = require("v-money");
var _constants = require("@/config/constants");
var _AppInput = _interopRequireDefault(require("@/ui/components/AppInput.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _vuex = require("vuex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getProductMetrics = function getProductMetrics(product) {
  var boxWeight = Number(product.kg) || 0;
  var boxPrice = Number(product.price) || 0;
  var quantity = Number(product.qtd) || 0;
  var totalWeight = boxWeight * quantity;
  var totalPrice = boxPrice * quantity;
  var convertedWeight = Number(product.convertion) || 0;
  var convertedQuantity = convertedWeight ? quantity * boxWeight / convertedWeight : 0;
  var convertedPrice = boxWeight ? convertedWeight * boxPrice / boxWeight : 0;
  var convertedTotalWeight = convertedWeight * convertedQuantity;
  var convertedTotalPrice = convertedPrice * convertedQuantity;
  return {
    boxWeight: boxWeight,
    boxPrice: boxPrice,
    quantity: quantity,
    totalWeight: totalWeight,
    totalPrice: totalPrice,
    convertedWeight: convertedWeight,
    convertedQuantity: convertedQuantity,
    convertedPrice: convertedPrice,
    convertedTotalWeight: convertedTotalWeight,
    convertedTotalPrice: convertedTotalPrice
  };
};
var _default2 = exports.default = {
  components: {
    AppInput: _AppInput.default,
    Money: _vMoney.Money
  },
  props: {
    romaneio: {
      type: Object,
      default: function _default() {}
    },
    title: {
      type: String,
      default: 'Detalhes do romaneio'
    }
  },
  data: function data() {
    return {
      money: _constants.MONEY,
      showWithoutConvertion: false
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })), {}, {
    hasConvertion: function hasConvertion() {
      var _this$romaneio;
      var products = ((_this$romaneio = this.romaneio) === null || _this$romaneio === void 0 ? void 0 : _this$romaneio.products) || [];
      return products.some(function (product) {
        return Number(product === null || product === void 0 ? void 0 : product.convertion) > 0;
      });
    }
  }),
  methods: {
    cancelModal: function cancelModal() {
      this.$parent.close();
    },
    toggleConvertion: function toggleConvertion() {
      this.showWithoutConvertion = !this.showWithoutConvertion;
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      return (0, _moment.default)(date).format('DD/MM/YY');
    },
    formatNumber: function formatNumber(number) {
      var formatted = Number(number);
      if (Number.isNaN(formatted)) return 0;
      return Math.round(formatted * 10000) / 10000;
    },
    shouldConvert: function shouldConvert(product) {
      return !this.showWithoutConvertion && Number(product === null || product === void 0 ? void 0 : product.convertion) > 0;
    },
    getWeightPerBox: function getWeightPerBox(product) {
      var _getProductMetrics = getProductMetrics(product),
        boxWeight = _getProductMetrics.boxWeight,
        convertedWeight = _getProductMetrics.convertedWeight;
      return this.formatNumber(this.shouldConvert(product) ? convertedWeight : boxWeight);
    },
    getBoxes: function getBoxes(product) {
      var _getProductMetrics2 = getProductMetrics(product),
        quantity = _getProductMetrics2.quantity,
        convertedQuantity = _getProductMetrics2.convertedQuantity;
      return this.formatNumber(this.shouldConvert(product) ? convertedQuantity : quantity);
    },
    getPricePerBox: function getPricePerBox(product) {
      var _getProductMetrics3 = getProductMetrics(product),
        boxPrice = _getProductMetrics3.boxPrice,
        convertedPrice = _getProductMetrics3.convertedPrice;
      return this.formatNumber(this.shouldConvert(product) ? convertedPrice : boxPrice);
    },
    getTotalPrice: function getTotalPrice(product) {
      var _getProductMetrics4 = getProductMetrics(product),
        totalPrice = _getProductMetrics4.totalPrice,
        convertedTotalPrice = _getProductMetrics4.convertedTotalPrice;
      return this.shouldConvert(product) ? convertedTotalPrice : totalPrice;
    },
    getTotalWeight: function getTotalWeight(product) {
      var _getProductMetrics5 = getProductMetrics(product),
        totalWeight = _getProductMetrics5.totalWeight,
        convertedTotalWeight = _getProductMetrics5.convertedTotalWeight;
      return this.shouldConvert(product) ? convertedTotalWeight : totalWeight;
    }
  }
};